import Layer from '../../../../Shared/Layer'
import { Trans, withTranslation } from 'react-i18next'
import Button from '../../../../Shared/Form/Button'
import React, { createRef, PureComponent } from 'react'
import Select from '../../../../Shared/Form/Select'
import { imageRejectReasons } from '../constants'
import Input from '../../../../Shared/Form/Input'
import PropTypes from 'prop-types'
import { deleteRejectInfo, putRejectImageInfo } from '../../../../../api'
import Loader from '../../../../Shared/Loader'

const rejectReasonOptions = Object.keys(imageRejectReasons).map((key) => {
  return { value: key, label: imageRejectReasons[key] }
})

const REJECT_TYPE_REJECTED = 7

class LayerRejectImage extends PureComponent {
  constructor () {
    super()
    this.state = {
      loading: false,
      value: null,
      reason: ''
    }
    this.layerRef = createRef()
  }

  updateStateFromProps () {
    let value = parseInt(rejectReasonOptions[0].value, 10)
    let reason = ''
    if (this.hasInfoRejected()) {
      value = this.props.image.infoRejected.type
      if (value === REJECT_TYPE_REJECTED && this.props.image.infoRejected.hasOwnProperty('reason')) {
        reason = this.props.image.infoRejected.reason
      }
    }
    this.setState({ value, reason })
  }

  componentDidMount () {
    this.updateStateFromProps()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props !== prevProps) {
      this.updateStateFromProps()
    }
  }

  onSelectChange = (e) => {
    const newValue = parseInt(e.target.value, 10)
    this.setState({ value: newValue })
    if (newValue !== REJECT_TYPE_REJECTED) {
      this.setState({ reason: '' })
    }
  }

  onReasonChange = (e) => {
    this.setState({ reason: e.target.value })
  }

  hasInfoRejected () {
    return this.props.image.hasOwnProperty('infoRejected') && this.props.image.infoRejected !== null
  }

  onSaveClick = () => {
    let info = {
      type: this.state.value
    }
    if (this.state.value === REJECT_TYPE_REJECTED) {
      info.reason = this.state.reason
    }
    this.setState({ loading: true }, () => {
      const { fetchPromise } = putRejectImageInfo(this.props.image.id, this.props.image.giataId, info)
      fetchPromise.then(() => {
        if (this.layerRef.current) {
          this.props.onHideClick()
        }
        this.setState({ loading: false })
        this.props.onRejected(info)
      }).catch(() => {
        this.setState({ loading: false })
      })
    })
  }

  onDeleteClick = () => {
    this.setState({ loading: true }, () => {
      const { fetchPromise } = deleteRejectInfo(this.props.image.id, this.props.image.giataId)
      fetchPromise.then(() => {
        if (this.layerRef.current) {
          this.props.onHideClick()
        }
        this.setState({ loading: false })
        this.props.onRejected(null)
      }).catch(() => {
        this.setState({ loading: false })
      })
    })
  }

  onCancelClick = () => {
    if (this.layerRef.current) {
      this.props.onHideClick()
    }
  }

  render () {
    const { t } = this.props
    return (
      this.props.show ?
        <Layer
          ref={this.layerRef}
          type="center"
          size="small"
          id={'reject_' + this.props.number}
          show={true}
          onHideClick={this.props.onHideClick}
          disallowHiding={this.state.loading}
        >
          {this.state.loading && <Loader size={32}/>}
          <h2><Trans>HEADLINE_REJECT_IMAGE</Trans></h2>
          <div>
            <Select options={rejectReasonOptions} selected={this.state.value} onChange={this.onSelectChange}/>
            {this.state.value === REJECT_TYPE_REJECTED &&
              <React.Fragment>
                <br/>
                <Input onChange={this.onReasonChange} value={this.state.reason} label={t('REJECT_REASON')}
                       required={true}/>
              </React.Fragment>}
          </div>
          <br/><br/>
          <Button align="right"
                  onClick={this.onSaveClick}><Trans>BUTTON_SAVE</Trans></Button>
          {this.hasInfoRejected() && <Button classNames="Button-Attention" align="right"
                                             style={{ marginRight: '5px' }}
                                             onClick={this.onDeleteClick}
          ><Trans>BUTTON_DELETE</Trans></Button>
          }
          <Button onClick={this.onCancelClick} classNames="Button-Light"><Trans>BUTTON_CANCEL</Trans></Button>
        </Layer>
        : null
    )
  }
}

LayerRejectImage.propTypes = {
  image: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  onRejected: PropTypes.func.isRequired,
  onHideClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}
export default withTranslation()(LayerRejectImage)
